import { useEffect, useState, useRef } from "react";
import { useAppDispatch } from "../../hooks/storeHooks";
import { fetchAllMasters } from "../../store/slices/detailedMaster/detailedMasterSlice";
import ContentMangements from "./ContentMangements";
import { getServerEnvironment } from "../../store/slices/constants/staticContents";

function ContentContainer() {
  const [filters, setFilters] = useState<any>({});
  const [expandedMap, setExpandedMap] = useState<any>({});
  const [pagination, setPagination] = useState<any>({
    EXAM: 1,
    GOAL: 1,
    SECTION: 1,
    UNIT: 1,
    TOPIC: 1,
    SUBTOPIC: 1,
    CLUSTER: 1,
    QUESTION: 1,
  });
  const dispatch = useAppDispatch();
  const prevFiltersRef = useRef<any>({});
  const prevPageRef = useRef<any>({});

  useEffect(() => {
    try {
      const stored = localStorage.getItem(
        btoa(`${getServerEnvironment()}-cross_exam`)
      );
      if (stored) {
        const decoded = atob(stored);
        const parsed = JSON.parse(decoded);
        if (parsed.expandedMap) {
          setExpandedMap(parsed.expandedMap);
        }
        if (parsed.filters) {
          setFilters(parsed.filters);
        }
        if (parsed.pagination) {
          setPagination(parsed.pagination);
        }
        // if (Array.isArray(parsed) && parsed.length > 0) {
        //   setExpandedMap(parsed);
        // }
      }
    } catch (err) {
      console.warn("Error reading copied data:", err);
    }
  }, []);
  useEffect(() => {
    try {
      const encoded = btoa(
        unescape(
          encodeURIComponent(
            JSON.stringify({
              filters: filters,
              expandedMap: expandedMap,
              pagination: pagination,
            })
          )
        )
      );
      localStorage.setItem(
        btoa(`${getServerEnvironment()}-cross_exam`),
        encoded
      );
    } catch (err) {
      console.warn("Error reading copied data:", err);
    }
  }, [filters, expandedMap, pagination]);
  useEffect(() => {
    dispatch(fetchAllMasters({ level: "exam" }));
  }, [dispatch]);
  useEffect(() => {
    const prevFilters = prevFiltersRef.current;
    const prevQuestionPage = prevPageRef.current;

    const fetchSequentially = async () => {
      try {
        const shouldRefetchAll = [
          "EXAMrefetch",
          "GOALrefetch",
          "SECTIONrefetch",
          "UNITrefetch",
          "TOPICrefetch",
          "SUBTOPICrefetch",
          "CLUSTERrefetch",
          "QUESTIONrefetch",
        ].some((key) => filters[key] !== prevFilters[key]);
        if (shouldRefetchAll) {
          // run all APIs in sequence
          await dispatch(fetchAllMasters({ level: "exam" })).unwrap();
          if (filters.EXAM)
            await dispatch(
              fetchAllMasters({ level: "goal", parent_id: filters.EXAM })
            ).unwrap();
          if (filters.GOAL)
            await dispatch(
              fetchAllMasters({ level: "section", parent_id: filters.GOAL })
            ).unwrap();
          if (filters.SECTION)
            await dispatch(
              fetchAllMasters({ level: "unit", parent_id: filters.SECTION })
            ).unwrap();
          if (filters.UNIT)
            await dispatch(
              fetchAllMasters({ level: "topic", parent_id: filters.UNIT })
            ).unwrap();
          if (filters.TOPIC)
            await dispatch(
              fetchAllMasters({ level: "subtopic", parent_id: filters.TOPIC })
            ).unwrap();
          if (filters.SUBTOPIC)
            await dispatch(
              fetchAllMasters({ level: "cluster", parent_id: filters.SUBTOPIC })
            ).unwrap();
          if (filters.CLUSTER)
            await dispatch(
              fetchAllMasters({ level: "question", parent_id: filters.CLUSTER })
            ).unwrap();

          // await dispatch(
          //   fetchClusterQuestions({
          //     level: "question",
          //     parent_id: filters.CLUSTER,
          //     page: pagination.QUESTION,
          //   })
          // ).unwrap();
        } else {
          // Only fetch APIs affected by changed main filter
          if (filters.EXAM !== prevFilters.EXAM) {
            await dispatch(
              fetchAllMasters({ level: "goal", parent_id: filters.EXAM })
            ).unwrap();
          }
          if (filters.GOAL !== prevFilters.GOAL) {
            await dispatch(
              fetchAllMasters({ level: "section", parent_id: filters.GOAL })
            ).unwrap();
          }
          if (filters.SECTION !== prevFilters.SECTION) {
            await dispatch(
              fetchAllMasters({ level: "unit", parent_id: filters.SECTION })
            ).unwrap();
          }
          if (filters.UNIT !== prevFilters.UNIT) {
            await dispatch(
              fetchAllMasters({ level: "topic", parent_id: filters.UNIT })
            ).unwrap();
          }
          if (filters.TOPIC !== prevFilters.TOPIC) {
            await dispatch(
              fetchAllMasters({ level: "subtopic", parent_id: filters.TOPIC })
            ).unwrap();
          }
          if (filters.SUBTOPIC !== prevFilters.SUBTOPIC) {
            await dispatch(
              fetchAllMasters({ level: "cluster", parent_id: filters.SUBTOPIC })
            ).unwrap();
          }
          if (
            filters.CLUSTER !== prevFilters.CLUSTER ||
            prevQuestionPage !== pagination.QUESTION
          ) {
            // await dispatch(
            //   fetchClusterQuestions({
            //     level: "question",
            //     parent_id: filters.CLUSTER,
            //     page: pagination.QUESTION,
            //   })
            // ).unwrap();
            await dispatch(
              fetchAllMasters({ level: "question", parent_id: filters.CLUSTER })
            ).unwrap();
          }
        }
      } catch (err) {
        console.error("Error fetching content:", err);
      }
    };

    fetchSequentially();
    prevFiltersRef.current = filters; // save current filters for next comparison
    prevPageRef.current = pagination.QUESTION;
  }, [filters, dispatch, pagination.QUESTION]);

  return (
    <ContentMangements
      setFilters={setFilters}
      setExpandedMap={setExpandedMap}
      expandedMap={expandedMap}
      setPagination={setPagination}
      pagination={pagination}
    />
  );
}

export default ContentContainer;
